import { CircleIcon, FilledIcon, NoneIcon, RombusIcon, StrokedIcon } from "@/icons/arrow-ends";

export const ARROW_END_ICONS = {
    none: NoneIcon,
    filled: FilledIcon,
    stroked: StrokedIcon,
    rombus: RombusIcon,
    circle: CircleIcon,
};
